import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-container-loader',
  templateUrl: './product-container-loader.component.html',
  styleUrls: ['./product-container-loader.component.scss']
})
export class ProductContainerLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
